import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { Country } from '../data/country';
import { State } from '../data/state';
import { Account } from '../data/account-info';
import { FleetBillingDetails } from '../data/fleet-billing-details';

@Injectable({
    providedIn: 'root',
})
export class AccountInfoService {

    private apiURL = `${environment.apiUrl}/api/AccountInfo`;

    constructor(private http: HttpClient) { }

    getAccountInfo(username: string): Observable<Account> {
        const url = `${this.apiURL}/getAccountInfo?username=${username}`;
        return this.http.get<Account>(url)
            .pipe(                
                catchError(this.handleError<Account>('getAccountInfo'))
            );
    }

    getCountries(role: string): Observable<Country[]> {
        const url = `${this.apiURL}/getCountries?role=${role}`;
        return this.http.get<Country[]>(url)
            .pipe(                
                catchError(this.handleError<Country[]>('getCountries'))
            );
    }

    getStates(): Observable<State[]> {
        const url = `${this.apiURL}/getStates`;
        return this.http.get<State[]>(url)
            .pipe(                
                catchError(this.handleError<State[]>('getStates'))
            );
    }

    updateAccount(account: Account, username: string): Observable<boolean> {
        const url = `${this.apiURL}/updateAccount?username=${username}`;
        return this.http.post<boolean>(url, account)
            .pipe(                
                catchError(this.handleError<boolean>('updateAccount'))
            );
    }

    getFleetDetails(username: string): Observable<FleetBillingDetails> {
        const url = `${this.apiURL}/getFleetBillingDetails?username=${username}`;
        return this.http.get<FleetBillingDetails>(url)
            .pipe(                
                catchError(this.handleError<FleetBillingDetails>('getFleetDetails'))
            );
    }

    updateFleetBillingDetails(details: FleetBillingDetails, username: string): Observable<boolean> {
        const url = `${this.apiURL}/fleet/updateDetails?updatedUser=${username}`;
        return this.http.post<boolean>(url, details)
            .pipe(                
                catchError(this.handleError<boolean>('updateFleetBillingDetails'))
            );
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    private log(message: string) {
        console.log(message);
    }
}